import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    FilterAltOutlined,
    TodayOutlined,
} from '@mui/icons-material'
import { Box, IconButton, Skeleton } from '@mui/material'
import { SearchField } from '@/components/SearchField'
import { TrackingsCalendar } from './TrackingsCalendar'
import { TrackingsProjectFilterChip } from './TrackingsProjectFilterChip'

export const TrackingsCalendarPendingComponent: React.FC<{
    searchText?: string
    start: Date
    projectIds?: string[]
}> = ({ searchText, start, projectIds }) => (
    <>
        <SearchField value={searchText} disabled={true} fullWidth={true} />

        <Box sx={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            <div>
                <IconButton size={'small'} disabled={true}>
                    <ArrowLeftOutlined />
                </IconButton>
                <IconButton size={'small'} disabled={true}>
                    <TodayOutlined />
                </IconButton>
                <IconButton
                    size={'small'}
                    disabled={true}
                    sx={{ marginRight: 2 }}
                >
                    <ArrowRightOutlined />
                </IconButton>
            </div>

            <IconButton disabled={true} size={'small'}>
                <FilterAltOutlined />
            </IconButton>

            {projectIds?.map(pId => (
                <TrackingsProjectFilterChip
                    key={pId}
                    projectName={<Skeleton width={100} />}
                />
            ))}
        </Box>

        <TrackingsCalendar projects={[]} trackings={[]} start={start} />
    </>
)
